<!--腹部、腹水及门静脉B超-->
<script setup>
import { ref,computed, reactive,watch } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

const crfStore = useCrfStore();


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});
let show = ref(false)
// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
watch(()=>model.fields[`${props.type}`]?.['脾脏硬度值_是否未测'],(newval,oldval)=>{
  if (newval?.length) {
  console.log(newval,'未测')
  model.fields[`${props.type}`]['脾脏硬度值（Kpa）'] = ''
  }
})
;


</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <h2>腹部、腹水及门静脉B超</h2>
      <upload :type="props.type" :data="model" name="fbfsjmjmbc"></upload>
      <check :period="props.type" text="腹部、腹水及门静脉B超" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="腹部、腹水及门静脉B超是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['腹部、腹水及门静脉B超是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['腹部、腹水及门静脉B超是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'患者是否新增腹部、腹水及门静脉B超检查？': '患者是否进行腹部、腹水及门静脉B超检查？'" class="redStar">
          <el-radio-group v-model="crfFields['患者是否进行腹部、腹水及门静脉B超检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields['患者是否进行腹部、腹水及门静脉B超检查？'] == '是'">
          <p style="padding: 5px;"></p>

          <el-form-item label="门静脉直径（mm）" :prop="itemProp(`mm`)" :rules="crfStore.textRules(`门静脉直径`,true)"  class="redStar" >
          <el-input v-model="crfFields['mm']" placeholder="请输入门静脉直径" autocomplete="off">
            <template #append>mm</template>
          </el-input>
            </el-form-item>
            
            <el-form-item label="门静脉血流速度（cm/s）" :prop="itemProp(`门静脉血流速度（cm/s）`)" :rules="crfStore.textRules(`门静脉血流速度`,true)"  class="redStar">
              <el-input v-model="crfFields['门静脉血流速度（cm/s）']"  placeholder="请输入门静脉血流速度" autocomplete="off">
                <template #append>cm/s</template>
              </el-input>
            </el-form-item>
            <el-form-item label="门静脉血栓" :prop="itemProp(`门静脉血栓`)" :rules="crfStore.radioRules(`门静脉血栓`,true)" class="redStar">
              <el-radio-group v-model="crfFields['门静脉血栓']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
         
            <el-form-item label="脾脏硬度值（Kpa）" :prop="itemProp(`脾脏硬度值（Kpa）`)" :rules="crfFields['脾脏硬度值_是否未测']?.length > 0 ||crfStore.textRules(`脾脏硬度值`,true)" class="not_redStar">
              <div style="display: flex;">
                <el-input v-model="crfFields['脾脏硬度值（Kpa）']" placeholder="请输入脾脏硬度值" :disabled="crfFields['脾脏硬度值_是否未测']?.length > 0 " autocomplete="off">
                </el-input>
                <el-checkbox-group v-model="crfFields['脾脏硬度值_是否未测']"  style="margin-left: 10px;">
                    <el-checkbox label="未测"></el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="脾长度（mm）" :prop="itemProp(`脾长度（mm）`)" :rules="crfStore.textRules(`脾长度`,true)"  class="redStar">
              <el-input v-model="crfFields['脾长度（mm）']" autocomplete="off" placeholder="请输入脾长度">
                  <template #append>mm</template>
              </el-input>
            </el-form-item>
            <el-form-item label="脾门厚度（mm）" :prop="itemProp(`脾门厚度（mm）`)" :rules="crfStore.textRules(`脾门厚度`,true)"  class="redStar">
              <el-input v-model="crfFields['脾门厚度（mm）']" autocomplete="off" placeholder="请输入脾门厚度">
                  <template #append>mm</template>
              </el-input>
            </el-form-item>
            <el-form-item label="胸水" :prop="itemProp(`胸水`)" :rules="crfStore.radioRules(`胸水`,true)"  class="redStar">
              <el-radio-group v-model="crfFields['胸水']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="腹水" :prop="itemProp(`腹水`)" :rules="crfStore.radioRules(`腹水`,true)"  class="redStar">
              <el-radio-group v-model="crfFields['腹水']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="腹部、腹水及门静脉B超">
                <el-input v-model="crfFields['腹部、腹水及门静脉B超']" autocomplete="off"
                placeholder="请输入腹部、腹水及门静脉B超报告"></el-input> 
            </el-form-item> -->
        </template>
      </template>
    <!-- <button class="button"  @click.prevent="show = !show">{{show? '隐藏选项':'展开选项'}}</button> -->

  </template>
</template>

<style scoped>
.ganjingmai{
  display: block ;
  width: 100%;
  .box{
    margin-left: 20px;
    width: 100%;
    padding-top: 10px;
   .top{
      margin-bottom: 18px;
    }
  }
}
.bar{
      display: flex;
      width: 100%;
      line-height: 1px !important;
      :deep(.el-input) {
      /* width: calc(100% - 230px); */
      width: 100%;
      flex-grow: 1;

      }
      
      .p{
        width: 230px ;
        color: rgb(96, 98, 102);
        margin-right: 0px;
        flex-shrink: 0;
        flex-grow: 0;
      }   
}

</style>